import qs from 'qs';
import { AxiosInstance } from 'axios';
import { NotificationListResource } from './resources';
import { CursorPaginationInput } from '@app/data/inputs';
import { DismissNotificationListInput } from './inputs';

export default class Notification {
    private basePath = '/api/notification';
    private http;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Get task message list
    get = async (pagination: CursorPaginationInput): Promise<NotificationListResource> => {
        const query = qs.stringify({ ...pagination });

        const { data } = await this.http.get(`${this.basePath}/?${query}`);

        return data;
    };

    // Dismiss certain or all notifications
    dismiss = async (input: DismissNotificationListInput): Promise<void> => {
        const { data } = await this.http.post(`${this.basePath}/dismiss`, input);

        return data;
    };
}
